"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotFoundError = void 0;
const UpsError_1 = require("./UpsError");
class NotFoundError extends UpsError_1.UpsError {
    constructor(message, details = {}) {
        super('NotFoundError', message, details);
    }
}
exports.NotFoundError = NotFoundError;
//# sourceMappingURL=NotFoundError.js.map